export default "/images/HEALIO.png?cf50181654dfa460e71f82699ed1ea3e";